import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from 'react';
export const IocContext = createContext(null);
export const IocProvider = ({ container, children }) => {
    return (_jsx(IocContext.Provider, { value: container, children: children }));
};
